export enum EnumStatusMedicamento {
    Revisao = 'Revisao',
    Ativo = 'Ativo',
    Desativado = 'Desativado'
}